import { render, staticRenderFns } from "./c-modal.vue?vue&type=template&id=2de0e60b&scoped=true&"
import script from "./c-modal.vue?vue&type=script&lang=js&"
export * from "./c-modal.vue?vue&type=script&lang=js&"
import style0 from "./c-modal.vue?vue&type=style&index=0&id=2de0e60b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de0e60b",
  null
  
)

export default component.exports